import React, { Component } from "react";
import { Helmet } from "react-helmet";

class HomePortfolio extends Component {
    render() {
        const buttonStyle = {
            margin: '12px auto',
            display: 'block',
            width: '100%',
            maxWidth: '340px',
            padding: '14px 28px',
            border: '1px solid rgba(255,255,255,0.85)',
            borderRadius: '42px',
            color: '#ffffff',
            textDecoration: 'none',
            textTransform: 'uppercase',
            letterSpacing: '0.18em',
            fontSize: '0.9rem',
            fontWeight: 600,
            backgroundColor: 'transparent',
            transition: 'background-color 0.25s ease, color 0.25s ease, transform 0.25s ease',
        };

        const imageStyle = {
            width: '220px',
            height: '220px',
            margin: '0 auto 8px',
            display: 'block',
            objectFit: 'contain',
        };

        return (
            <div style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden', backgroundColor: '#000' }}>
                <Helmet>
                    <title>Graydon Lofts</title>
                    <meta name="description" content="Graydon Lofts - 26 East Sixth Street, Cincinnati Ohio" />
                    <link rel="icon" type="image/png" href="/assets/images/tea/favicon.png" />
                </Helmet>

                <style>{`
                    .graydon-button:hover {
                        background-color: rgba(255,255,255,0.12);
                        color: #ffffff;
                        transform: translateY(-1px);
                    }
                    .graydon-contact:hover {
                        color: rgba(255,255,255,0.82);
                    }
                `}</style>

                <div style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundImage: 'linear-gradient(rgba(0,0,0,0.32), rgba(0,0,0,0.32)), url(/assets/images/bg/bg-image-34.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }} />

                <div style={{
                    position: 'relative',
                    zIndex: 2,
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '22px',
                    textAlign: 'center',
                    color: '#ffffff',
                }}>
                    <img src="/assets/images/tea/logo.png" alt="Graydon Lofts" style={imageStyle} />

                    <div style={{ maxWidth: '720px' }}>
                        <h1 style={{ fontSize: '2.35rem', fontWeight: 400, margin: '0 0 8px', color: '#ffffff' }}>Graydon Lofts</h1>
                        <p style={{ fontSize: '1.05rem', lineHeight: 1.9, margin: 0 }}>26 East Sixth Street, Cincinnati Ohio</p>
                    </div>

                    <div style={{ width: '100%', maxWidth: '360px', marginTop: '40px' }}>
                        <a href="https://www.redfin.com/OH/Cincinnati/26-E-6th-St-Cincinnati-OH-45202/building/11714" className="graydon-button" style={buttonStyle}>UNITS FOR SALE IN BUILDING</a>
                        <a href="https://lbmanagement.securecafe.com/residentservices/lofts-at-graydon-place-unit-owners-association-inc/userlogin.aspx" className="graydon-button" style={buttonStyle}>RESIDENT LOGIN</a>
                        <a href="mailto:contact@graydonlofts.com" className="graydon-contact" style={{ display: 'inline-block', marginTop: '28px', color: '#ffffff', textDecoration: 'none', fontSize: '1rem', fontWeight: 500, letterSpacing: '0.1em' }}>Contact Us</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomePortfolio;